import { useQuery } from '@tanstack/react-query';
import { ROUTES, type BrainRun } from '@serb/shared';
import { api } from '../../api/client';
import { KEYS } from '../../api/keys';
import { SAMPLE_DATA } from '../../lib/sample';

/** Claude running on the server: whether it is switched on, and its recent runs (newest first) */
export function useBrain() {
  const q = useQuery({
    queryKey: KEYS.brain,
    queryFn: () => api.get<{ enabled: boolean; runs: BrainRun[] }>(ROUTES.api.brain),
    enabled: !SAMPLE_DATA,
  });
  const runs = q.data?.runs ?? [];
  return {
    enabled: q.data?.enabled ?? false,
    runs,
    running: runs[0]?.status === 'running',
    last: runs.find((r) => r.status !== 'running'),
    wake: () => api.post(ROUTES.api.brainWake),
  };
}
